import { Button } from "@/components/ui/button";
import { Price } from "../PurchaseModal";
import { useRef } from "react"

export function PurchaseOptions({ onPurchase, prices }: { onPurchase: (priceId: string) => void, id: string, prices: Price[] }) {
    const bonusAmounts = [5, 2];
    const reversedPrices = [...prices].reverse();
    const hasClickedRef = useRef(false);
    
    const handlePurchaseClick = (priceId: string) => {
        if (hasClickedRef.current) {
            return;
        }
        
        hasClickedRef.current = true;
        onPurchase(priceId);
    };
    
    
    return (
        <div className="flex flex-col space-y-8 w-full p-4 pb-0 h-56">
            {reversedPrices.map((price, index) => (
                <div 
                    key={price.id} 
                    className={`relative ${index < 2 ? "btn-bounce-subtle" : ""}`}
                >
                    <Button 
                        className="py-7 bg-blue text-white text-2xl font-bold rounded-lg w-full mb-0 z-50"
                        shine
                        onClick={() => handlePurchaseClick(price.id)}
                        bounceEffect={index < 2 ? "none" : undefined}
                    >
                        <div className='flex justify-between items-center w-full'>
                            <span className="text-white">{price.totalCards} {price.totalCards === 1 ? "card" : "cards"}</span>
                            <span className="text-white">${(price.price / 100)}</span>
                        </div>
                    </Button>
                    
                    {index < 2 && !price.id.includes('gold') && (
                        <span className='text-sm px-2 pt-2 bg-green-500 text-white font-semibold absolute -bottom-5 left-0 rounded-b-sm z-0'>
                            +${bonusAmounts[index]} promo cash bonus
                        </span>
                    )}
                </div>
            ))}
        </div>
    )
}